import {action, observable} from "mobx";
import {INotice} from "../models/notice";
import BaseStore from "./base/base-store";
import RootStore from "./root-store";

export default class ToasterStore extends BaseStore {

    @observable
    public notices: INotice[];

    constructor(rootStore: RootStore) {
        super(rootStore);
    }

    @action
    public addNotice(notice: INotice) {
        this.initNotices();
        this.notices.push(notice);
    }

    @action
    public setNotices() {
        this.notices = [];
    }

    private initNotices() {
        if (!this.notices) {
            this.setNotices();
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/toaster-store.ts